// Barra de Aforo — visible en el tablero Valet cuando hay turno abierto (presentacional puro).
export const AforoBar = ({ aforo }) => (
  <div className="px-5 lg:px-8 pt-5">
    <div className={`flex items-center justify-between p-4 border ${aforo?.lleno ? "bg-[#EF4444] border-[#EF4444]" : "bg-white/5 border-white/15"}`} data-testid="valet-aforo-indicator">
      <div>
        <p className={`text-[10px] tracking-[0.2em] uppercase font-bold ${aforo?.lleno ? "text-white/80" : "text-white/50"}`}>Aforo · Disponibles</p>
        {aforo?.capacidad_total == null ? (
          <p className="font-display text-xl font-black mt-1 text-white/60">Sin capacidad configurada</p>
        ) : aforo?.lleno ? (
          <p className="font-display text-4xl font-black mt-1 tracking-tight" data-testid="valet-aforo-lleno">LLENO</p>
        ) : (
          <p className="font-display text-4xl font-black mt-1 tracking-tight text-[#FFCC00]" data-testid="valet-aforo-disponibles">
            {aforo?.disponibles}<span className="text-white/40 text-xl"> / {aforo?.capacidad_total}</span>
          </p>
        )}
      </div>
      <div className="text-right">
        <p className="text-[10px] tracking-[0.2em] uppercase font-bold text-white/50">Activos</p>
        <p className="font-display text-2xl font-black">{aforo?.activos ?? 0}</p>
      </div>
    </div>
  </div>
);

export default AforoBar;
